export default function Footer() {
  return (
    <div>
      <footer className="footer" data-testid="footer">
        <div>
          <a className="text-muted" href="https://github.com/matiasraisanen/food-fight">source @github</a>
        </div>
      </footer>
    </div>
  );
}